import { Event, NavigationEnd } from '@angular/router';
import { OperatorFunction, filter } from 'rxjs';

export const filterNavigationEnd: OperatorFunction<Event, NavigationEnd> = filter(
  (event: Event): event is NavigationEnd => event instanceof NavigationEnd
);
